import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
export const isAuthenticatedQuery = gql `
  query isAuthenticated {
    isAuthenticated: isAuthenticatedV2
  }
`;
export const useIsAuthenticated = (props = {}) => {
    const useQuery = props.useQuery || defaultUseQuery;
    const { data, error, loading } = useQuery(isAuthenticatedQuery, {
        skip: props.skip,
    });
    return {
        error,
        isAuthenticated: Boolean(data === null || data === void 0 ? void 0 : data.isAuthenticated),
        isLoading: loading,
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
